/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { UpdateFuturesTradeAccountsByIdRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class FuturesTradeAccountsMassUpdates<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name UpdateFuturesTradeAccounts
   * @request POST:/futuresTradeAccounts-mass-updates
   * @secure
   */
  updateFuturesTradeAccounts = (
    data: UpdateFuturesTradeAccountsByIdRequest,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/futuresTradeAccounts-mass-updates`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsFuturesTradeAccountsMassUpdates
   * @request OPTIONS:/futuresTradeAccounts-mass-updates
   */
  optionsFuturesTradeAccountsMassUpdates = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/futuresTradeAccounts-mass-updates`,
      method: 'OPTIONS',
      ...params,
    });
}
